import { Fragment, useState, useEffect } from "react";
import { Col, Card, Row, Button, Badge } from "react-bootstrap";
import { Container, Box, Typography } from "@mui/material";
import "./courses-new.css";
import {
  getHomeCoursesData,
  getHomeCourseTitle,
  getHomeCoursesDescription,
} from "../../../utils/firebase/firebase.utils";

const localcourseData = [
  {
    title: "Regular Classroom Courses",
    text: "Join Classroom Course for WBCS Basic Courses,Prelims,Mains and Personality Test.",
    border: "light",
    bg: "info",
    url: "/regular-classroom-course",
    badge: "",
  },
  {
    title: "Weekend Batches for WBCS",
    text: "Weekend batches are specially for working professionals. Owing to the nature of their jobs, many professionals can’t join the regular batches in our institute. ",
    border: "warning",
    bg: "success",
    url: "/wbcs-weekend-batches",
    badge: "",
  },
  {
    title: "WBCS Correspondence Courses",
    text: "For the aspirants of distant areas or working professionals who are unable to make use of classroom guidance program, Correspondence Course is the first choice. ",
    border: "light",
    bg: "warning",
    url: "/wbcs-correspondence-courses",
    badge: "",
  },
  {
    title: "Test Series for Prelims & Mains",
    text: "Boost your WBCS exam preparation and score better with Our WBCS Test Series for WBCS Prelims and Mains.",
    border: "warning",
    bg: "danger",
    url: "/test-series",
    badge: "",
  },
  {
    title: "Online WBCS Coaching",
    text: "Our Live Classes is dedicated platform that offers Online WBCS Coaching Classes for entire WBCS examinations. ",
    border: "light",
    bg: "warning",
    url: "/online-wbcs-coaching",
    badge: "",
  },
  {
    title: "WBCS Consultant Guidance",
    text: "Confused about WBCS Preparation? Request counselling Now",
    border: "warning",
    bg: "info",
    url: "/wbcs-consultant-guidance",
    badge: "NEW",
  },
];

const CoursesNewCard = () => {
  const [courseData, SetCourseData] = useState(localcourseData);

  const [courseTitle, SetCourseTitle] = useState();

  const [courseDescription, SetCourseDescription] = useState();

  useEffect(() => {
    const getCourseData = async () => {
      const getDataFromDatabase = await getHomeCoursesData("courses");
      const getCourseTitle = await getHomeCourseTitle();
      const getCourseDescription = await getHomeCoursesDescription();
      SetCourseTitle(getCourseTitle);
      SetCourseData(getDataFromDatabase);
      SetCourseDescription(getCourseDescription);
    };

    getCourseData();
  }, []);

  return (
    <div className="section-courses">
      <div className="container">
        <h2 className="heading-secondary">{courseTitle}</h2>
        <p className="header-description margin-bottom-m">
          {courseDescription}
        </p>
        <div className="grid grid--3-cols">
          {courseData.map((course, i) => {
            let bgColor = null;
            if (i === 0) {
              bgColor = "#ffe066";
            } else if (i === 1) {
              bgColor = "#fcc2d7";
            } else if (i === 2) {
              bgColor = "#e599f7";
            } else if (i === 3) {
              bgColor = "#a9e34b";
            } else if (i === 4) {
              bgColor = "#ffa94d";
            } else if (i === 5) {
              bgColor = "#fcc419";
            }
            return (
              <div className="course-card" style={{ backgroundColor: bgColor }}>
                <h3 className="heading-tertiary">{course.title}</h3>
                <p className="course-description">{course.text}</p>
                <a href={course.url} className="btn-card">
                  Know more&rarr;
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CoursesNewCard;
